module.exports = __webpack_public_path__ + "static/media/icon-back.dfb32f95.svg";